export function tabId(idPrefix: string, key: string) {
  return `${idPrefix}-tab-${key}`
}

export function tabPanelId(idPrefix: string, key: string) {
  return `${idPrefix}-panel-${key}`
}

/** Attributs du panneau d'un onglet : à poser sur l'élément qui contient son contenu. */
export function tabPanelProps(idPrefix: string, key: string) {
  return {
    role: 'tabpanel' as const,
    id: tabPanelId(idPrefix, key),
    'aria-labelledby': tabId(idPrefix, key),
    tabIndex: 0,
  }
}
